// Configurator cart shim. Two jobs on the /cart page:
//   1. Enforce the Hardware Pack quantity = number of complete, compatible kits
//      in the cart (one per kit). Auto add / adjust / remove via the Cart AJAX
//      API; any manual change snaps back. Reloads once after a correction so
//      Eurus's Alpine cart re-renders with the corrected contents.
//   2. Show the same non-blocking kit notice as the widget.
// Rules come from the metafield-driven blob — never hardcoded.
(function () {
  var rulesEl = document.getElementById('sc-kit-rules');
  var noticeEl = document.getElementById('sc-kit-notice');
  if (!rulesEl) return; // not the cart page (or section absent)

  var rules;
  try {
    rules = JSON.parse(rulesEl.textContent);
  } catch (e) {
    return;
  }

  // Kit definition comes from the collection's kit_rules metafield (one source,
  // shared with the widget). Falls back to Schema's original four-type kit +
  // plate/pcb advisory if the metafield is absent. PCB is optional by default.
  var kitRules = rules.kitRules || {};
  var KIT_TYPES = Array.isArray(kitRules.required) && kitRules.required.length
    ? kitRules.required
    : ['top_case', 'bottom_case', 'weight', 'plate'];
  var COMPAT = Array.isArray(kitRules.compatibility) && kitRules.compatibility.length
    ? kitRules.compatibility
    : (rules.kitRules ? [] : [{ a: 'plate', b: 'pcb', on: 'switch_type' }]);
  var components = rules.components || {}; // productId -> component_type
  var switchTypes = rules.switchTypes || {}; // variantId -> MX/HE/EC
  var requiredAddon = rules.requiredAddon || null; // { productId, variantId, perKit } | null
  var perKit = requiredAddon && requiredAddon.perKit > 0 ? requiredAddon.perKit : 1;

  var LOG = '[configurator-cart-shim]';
  // Loop guard: skip if we issued a correction in the last few seconds. Auto-
  // expires (timestamp), so it can never permanently block enforcement.
  var TS_KEY = 'sc-hw-ts';
  function recentlyCorrected() {
    return Date.now() - parseInt(sessionStorage.getItem(TS_KEY) || '0', 10) < 4000;
  }

  // Number of complete keyboards = min qty across the kit types, 0 if any missing.
  function kitCount(cart) {
    var totals = {};
    KIT_TYPES.forEach(function (t) {
      totals[t] = 0;
    });
    (cart.items || []).forEach(function (item) {
      var type = components[String(item.product_id)];
      if (KIT_TYPES.indexOf(type) !== -1) totals[type] += item.quantity;
    });
    if (KIT_TYPES.some(function (t) { return totals[t] === 0; })) return 0;
    return Math.min.apply(
      null,
      KIT_TYPES.map(function (t) { return totals[t]; }),
    );
  }

  // Advisory: for each compatibility pair, both sides are in the cart but no
  // selected pair shares a value on the rule's axis. Only switch_type is modeled.
  function incompatible(cart) {
    return COMPAT.some(function (rule) {
      if (rule.on !== 'switch_type') return false;
      var aVals = {};
      var bVals = {};
      (cart.items || []).forEach(function (item) {
        var type = components[String(item.product_id)];
        var st = switchTypes[String(item.variant_id)];
        if (!st) return;
        if (type === rule.a) aVals[st] = true;
        if (type === rule.b) bVals[st] = true;
      });
      var ak = Object.keys(aVals);
      var bk = Object.keys(bVals);
      return !!(ak.length && bk.length && !ak.some(function (t) { return bVals[t]; }));
    });
  }

  function evaluateNotice(cart) {
    var present = {};
    var configuratorItems = 0;
    (cart.items || []).forEach(function (item) {
      var type = components[String(item.product_id)];
      if (!type) return;
      configuratorItems++;
      present[type] = true;
    });
    if (configuratorItems === 0) return null;
    var missing = KIT_TYPES.filter(function (t) { return !present[t]; });
    if (missing.length > 0) {
      return "What you're ordering is not a complete keyboard kit. You can still place the order.";
    }
    if (incompatible(cart)) {
      return 'Your plate and PCB switch types aren’t compatible. This won’t work as a complete keyboard, but you can still order the parts.';
    }
    return null;
  }

  // Disable checkout while we might still be adjusting the Hardware Pack count,
  // so a customer can't check out mid-correction with the wrong quantity.
  function setCheckout(enabled) {
    var btns = document.querySelectorAll(
      '[name="checkout"], button[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]',
    );
    btns.forEach(function (b) {
      if (enabled) {
        b.removeAttribute('disabled');
        b.style.pointerEvents = '';
        b.style.opacity = '';
      } else {
        b.setAttribute('disabled', 'disabled');
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.5';
      }
    });
  }

  function renderNotice(message) {
    if (!noticeEl) return;
    if (message) {
      noticeEl.textContent = message;
      noticeEl.hidden = false;
    } else {
      noticeEl.textContent = '';
      noticeEl.hidden = true;
    }
  }

  // Returns true if a correction was issued (caller should stop; page reloads).
  function enforceHardwarePack(cart) {
    if (!requiredAddon) return false;
    var desired = kitCount(cart) * perKit;
    var line = (cart.items || []).filter(function (it) {
      return String(it.product_id) === String(requiredAddon.productId);
    })[0];
    var current = line ? line.quantity : 0;
    if (current === desired) return false;
    if (recentlyCorrected()) return false; // just acted — let the reload settle

    sessionStorage.setItem(TS_KEY, String(Date.now()));
    var request;
    if (current > 0) {
      request = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: desired }),
      });
    } else {
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(requiredAddon.variantId), quantity: desired }] }),
      });
    }
    request
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error(r.status + ' ' + t); });
        window.location.reload();
      })
      .catch(function (e) {
        console.error(LOG, 'correction failed:', e);
        renderNotice(evaluateNotice(cart));
      });
    return true;
  }

  function refresh() {
    if (requiredAddon) setCheckout(false); // lock until we confirm the count
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (enforceHardwarePack(cart)) return; // correcting → page will reload
        renderNotice(evaluateNotice(cart));
        setCheckout(true); // settled — safe to check out
      })
      .catch(function (e) {
        console.error(LOG, 'refresh failed:', e);
        setCheckout(true); // don't strand the customer if our check errors
      });
  }

  var refreshTimer;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 350); // debounce Eurus's re-renders
  }

  refresh();

  // Eurus updates the cart via AJAX and re-renders without firing standard
  // events, so watch the cart container for any change and re-check.
  var cartRoot =
    document.getElementById('main-cart-items') ||
    document.querySelector('.cart-items') ||
    document.querySelector('form[action$="/cart"]');
  if (cartRoot && 'MutationObserver' in window) {
    new MutationObserver(scheduleRefresh).observe(cartRoot, { childList: true, subtree: true });
  }
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, scheduleRefresh);
  });
  window.addEventListener('pageshow', refresh);
})();
